
export const firebaseConfig = {
  apiKey: "AIzaSyD1W8JjXOOMq5oi3dp2Xhu1i4WZHL8RiqI",
  authDomain: "black-widow-rand.firebaseapp.com",
  projectId: "black-widow-rand",
  storageBucket: "black-widow-rand.firebasestorage.app",
  messagingSenderId: "269000336764",
  appId: "1:269000336764:web:b53c2bb13c8df857faf0f9",
};

